import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useDate, useDateLimits, useScreen } from '../../../../../hooks'
import Button from '../../../../Button'
import { DateTimePicker } from '../../../../DateTime'
import { FormikField } from '../../../../Formik'
import {
  NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE,
  NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE,
} from '../../NewsboardPostForm.constants'

import { TIME_RANGE_FIELD_SEPARATOR } from './TimeRangeField.constants'

import * as styles from './TimeRangeField.module.css'

function TimeRangeField() {
  const { t } = useTranslation()
  const { maxDate } = useDateLimits()
  const { setFieldValue, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const date = useDate()

  const {
    [NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE]: endDate,
    [NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE]: startDate,
  } = values

  const handleClickPublishNow = useCallback(() => {
    setFieldValue(NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE, date)
  }, [date, setFieldValue])

  return (
    <>
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t('Newsboard.TimeRangeStartFieldDatePlaceholderKey'),
          selectProps: {
            children: (
              <Button.Text
                className={styles.publishNow}
                text={t('Newsboard.PublishNowKey')}
                onClick={handleClickPublishNow}
              />
            ),
          },
          wrapperClassName: styles.datePickerWrap,
        }}
        fieldComponentProps={{
          label: `${t('Newsboard.TimeRangeFieldDateLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={endDate ?? maxDate}
        minValue={date}
        name={NEWSBOARD_POST_FORM_FIELD_NAME_START_DATE}
        separator={TIME_RANGE_FIELD_SEPARATOR}
        timeProps={{
          placeholder: t('Newsboard.TimeRangeStartFieldTimePlaceholderKey'),
          wrapperClassName: styles.timePickerWrap,
        }}
      />
      <FormikField
        Component={DateTimePicker}
        borderless={!isMobileScreenSize}
        dateProps={{
          placeholder: t('Newsboard.TimeRangeEndFieldDatePlaceholderKey'),
          wrapperClassName: styles.datePickerWrap,
        }}
        fieldComponentProps={{
          label: true,
          shouldAdaptToMobileScreen: true,
        }}
        maxValue={maxDate}
        minValue={startDate ?? date}
        name={NEWSBOARD_POST_FORM_FIELD_NAME_END_DATE}
        separator={TIME_RANGE_FIELD_SEPARATOR}
        timeProps={{
          placeholder: t('Newsboard.TimeRangeEndFieldTimePlaceholderKey'),
          wrapperClassName: styles.timePickerWrap,
        }}
      />
    </>
  )
}

export default TimeRangeField
